// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../vue3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../vue3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge.status-0{background-color:#ec4c2c;color:#fff}.status-color-0{color:#ec4c2c}.status-background-0{background:#ec4c2c}.status-border-0{border-color:#ec4c2c}.badge.status-25{background-color:#fe7c1a;color:#fff}.status-color-25{color:#fe7c1a}.status-background-25{background:#fe7c1a}.status-border-25{border-color:#fe7c1a}.badge.status-50{background-color:#f9af1f;color:#fff}.status-color-50{color:#f9af1f}.status-background-50{background:#f9af1f}.status-border-50{border-color:#f9af1f}.badge.status-75{background-color:#e0db38;color:#fff}.status-color-75{color:#e0db38}.status-background-75{background:#e0db38}.status-border-75{border-color:#e0db38}.badge.status-100{background-color:#b6f762;color:#fff}.status-color-100{color:#b6f762}.status-background-100{background:#b6f762}.status-border-100{border-color:#b6f762}.badge.status-200{background-color:#a0a0a0;color:#fff}.status-color-200{color:#a0a0a0}.status-background-200{background:#a0a0a0}.status-border-200{border-color:#a0a0a0}.badge.status-250{background-color:#a0a0a0;color:#fff}.status-color-250{color:#a0a0a0}.status-background-250{background:#a0a0a0}.status-border-250{border-color:#a0a0a0}.status-normal{color:#4db348}.status-info{color:#3d74ff}.status-warning{color:#ffd014}.status-critical{color:#ff1919}.status-ok{color:green}.status-open-tickets{color:gray}`, ""]);
// Exports
var _1 = `#ddd`;
export { _1 as "gray-650" };
var _2 = `#dadada`;
export { _2 as "gray-710" };
var _3 = `#616879`;
export { _3 as "gray-1105" };
var _4 = `#f9af1f`;
export { _4 as "status-color-50" };
var _5 = `#09c`;
export { _5 as "vcom-blue" };
var _6 = `#ff5262`;
export { _6 as "slider-critical-color" };
var _7 = `#ffdf3d`;
export { _7 as "slider-major-light-color" };
var _8 = `#ffe977`;
export { _8 as "slider-major-dark-color" };
var _9 = `#a6a6a6`;
export { _9 as "slider-minor-light-color" };
var _a = `#c3c3c4`;
export { _a as "slider-minor-dark-color" };
export default ___CSS_LOADER_EXPORT___;
